import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RegisterActive from './UserActive/RegisterActive'
import SetPaaword from './UserActive/SetPaaword'

class UserActive extends Component {
    state = {
    }
    render() {
        const { match: { params: { condition } } } = this.props
        return (    
            <Container>
                {condition === 'activate' && <RegisterActive/>}
                {condition === 'setPassword' && <SetPaaword/>}
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User
    }
}
export default withRouter(connect(mapStateToProps)(UserActive));
const Container = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    /* height: calc(100% - 120px); */
    /* 扣除footer高度 */
    top: 0;
    left: 0;
    z-index: 5000;
    background: #fafafa;
`


// WEBPACK FOOTER //
// ./src/User/UserActive.js